import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cn } from '@/lib/utils';

export interface ButtonGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  orientation?: 'horizontal' | 'vertical';
  asChild?: boolean;
}

/**
 * ButtonGroup component using Radix UI Slot for flexible composition.
 * Handles layout, spacing, and accessibility for grouped buttons.
 */
export const ButtonGroup = React.forwardRef<HTMLDivElement, ButtonGroupProps>(
  (
    {
      children,
      orientation = 'horizontal',
      asChild = false,
      className = '',
      ...props
    },
    ref
  ) => {
    const Comp = asChild ? Slot : 'div';
    return (
      <Comp
        ref={ref}
        role="group"
        aria-orientation={orientation}
        className={cn(
          'inline-flex',
          orientation === 'vertical' ? 'flex-col' : 'flex-row',
          'gap-2',
          className
        )}
        {...props}
      >
        {children}
      </Comp>
    );
  }
);
ButtonGroup.displayName = 'ButtonGroup';
